import type { GroupResource, UserResource } from 'entities/document/model';

export const convertParticipantGroupToParticipantUsers = (
  group: GroupResource<any>,
): UserResource[] | any => group.parameters.participants;
